import 'babel-polyfill'
import 'utils/ie11-polyfills'
import React from 'react'
import { render, hydrate } from 'react-dom'
import './index.css'
import App from './App'
import { BrowserRouter } from 'react-router-dom'

const rootElement = document.getElementById('root')
if (rootElement.hasChildNodes()) {
  hydrate(
    <BrowserRouter>
      <App />
    </BrowserRouter>, rootElement)
} else {
  render(
    <BrowserRouter>
      <App />
    </BrowserRouter>, rootElement)
}



// WEBPACK FOOTER //
// ./src/index.js